import React from "react";
import PropTypes from "prop-types";

function CharacterLimitIndicator({ fieldName, length, maxLength }) {
  return (
    <span
      className={`badge rounded-pill float-end ${
        length > maxLength ? "text-white bg-danger" : "bg-secondary text-light"
      }`}
      id={`${fieldName}-count`}
    >
      {length}/{maxLength}
    </span>
  );
}

CharacterLimitIndicator.propTypes = {
  fieldName: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
};

export default CharacterLimitIndicator;
